/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Drop_Frame_HelpInputs */



/**
* | output |
* | --- |
* | "Use drop frame timecode" |
*
* @param {Embed_Captions_Drop_Frame_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_drop_frame_help = /** @type {((inputs?: Embed_Captions_Drop_Frame_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Drop_Frame_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Utiliser le timecode drop frame")
	if (locale === "de") return /** @type {LocalizedString} */ ("Verwenden Sie Drop-Frame-Timecode.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Utilizza il timecode drop frame")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Используйте временной код для пропуска кадров.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Usar código de tiempo de eliminación de fotogramas")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("使用丢帧时间码")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ドロップフレームタイムコードを使用する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ड्रॉप फ्रेम टाइमकोड का उपयोग करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Use o código de tempo drop frame.")
	return /** @type {LocalizedString} */ ("Use drop frame timecode")
});